// libs
import { HTMLMotionProps, motion } from "framer-motion";
import styled, { css } from "styled-components";
// components
import Icon from "./Icon";
// other
import { IconKey } from "../models/client";
import { Colors } from "../models/theme";

interface ButtonProps extends HTMLMotionProps<"button"> {
  icon?: IconKey;
  color?: keyof Colors;
}

const ButtonWrapper = styled(motion.button)<{
  $hasIcon: boolean;
  color: keyof Colors;
}>`
  position: relative;
  height: 64px;
  line-height: 64px;
  background-color: ${({ theme, color }) => theme.colors[color]};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 32px;
  min-width: 120px;
  border: none;
  outline: none;
  padding: 0 32px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.2);

  ${({ $hasIcon }) =>
    $hasIcon
      ? css`
          padding-right: 56px;
        `
      : null}
`;

const IconContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 24px;
  height: 24px;
  width: 24px;
  line-height: 1;
  transform: translateY(-50%);

  svg {
    color: white;
    height: 24px;
    width: 24px;
  }
`;

function Button({ children, icon, color = "blueDark", ...rest }: ButtonProps) {
  return (
    <ButtonWrapper
      $hasIcon={icon !== undefined}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 1 }}
      color={color}
      {...rest}
    >
      {children}
      {icon ? (
        <IconContainer>
          <Icon icon={icon} />
        </IconContainer>
      ) : null}
    </ButtonWrapper>
  );
}

export default Button;
